/**
 * `/metal-solutions/industries/medical-systems/`: the old URL of the Medical, Health & Safety page,
 * kept as a redirect. The page renders nothing and, once mounted in the browser, sends the visitor
 * to `/metal-solutions/industries/medical-health-safety` (`../medical-health-safety/index.tsx`).
 * It is a browser-side redirect, not an HTTP one: the static export has no redirects
 * (`next.config.js`), so this page's effect sets `window.location.href`. It has no
 * `getStaticProps`, so unlike the industry pages it is built for every brand.
 */
import React from "react";

/** Redirects to the Medical, Health & Safety page on mount; see the file header. */
export default () => {
	React.useEffect(() => {
		window.location.href = "/metal-solutions/industries/medical-health-safety";
	}, []);
	return <></>;
};
